import { createApp } from 'vue'
import App from './App.vue'
// import VueRouter from 'vue-router'

createApp(App).mount('#app')
